import { roleGuard } from '../../core/guards/role.guard';
import { energyInterfacesLoadedGuard } from '../energy-interfaces/guards/energy-interfaces-loaded.guard';
import { locationsLoadedGuard } from '../locations/guards/locations-loaded.guard';
import { parseRequestsLoadedGuard } from '../parse-requests/guards/parse-requests-loaded.guard';
import { supplierContractLoadedGuard } from './guards/supplier-contract-loaded.guard';
import { supplierContractChecksStoreSetupGuard } from './guards/supplier-contract-checks-store-setup.guard';
import { supplierContractChecksLoadedGuard } from './guards/supplier-contract-checks-loaded.guard';
import { SupplierContractDetailsCheckPage } from './pages/supplier-contract-details-check-page/supplier-contract-details-check-page';
import { SupplierContractDetailsGeneralPage } from './pages/supplier-contract-details-general-page/supplier-contract-details-general-page';
import { SupplierContractsDetailsPage } from './pages/supplier-contracts-details-page/supplier-contracts-details-page';
import { SupplierContractsDetailsPricePage } from './pages/supplier-contracts-details-price-page/supplier-contracts-details-price-page';
import { SupplierContractsPage } from './pages/supplier-contracts-page/supplier-contracts-page';
import { Routes } from '@angular/router';
import { SupplierContractChecksStore } from './stores/supplier-contract-checks.store';
import { videoTutorialsLoadedGuard } from '../tutorials/guards/video-tutorials-loaded.guard';
import { featureFlagGuard } from '../../core/guards/feature-flag.guard';
import { supplierContractDraftLoadedGuard } from './guards/supplier-contract-draft-loaded.guard';

export const SUPPLIER_CONTRACTS_ROUTES: Routes = [
  {
    path: '',
    canActivate: [
      energyInterfacesLoadedGuard,
      locationsLoadedGuard,
      parseRequestsLoadedGuard,
      videoTutorialsLoadedGuard,
    ],
    component: SupplierContractsPage,
  },
  {
    path: 'create',
    redirectTo: 'legacy/create',
  },
  {
    path: 'legacy/create',
    canActivate: [roleGuard('USER_ADMIN'), parseRequestsLoadedGuard],
    loadComponent: () =>
      import('./legacy/supplier-contract-create-page/supplier-contract-create-page').then(
        (c) => c.SupplierContractCreatePage,
      ),
  },
  {
    path: ':supplierContractId/create',
    canActivate: [
      roleGuard('USER_ADMIN'),
      featureFlagGuard('supplierContractCreate', '../legacy/create'),
      supplierContractDraftLoadedGuard,
    ],
    loadComponent: () =>
      import('./pages/supplier-contract-create-page/supplier-contract-create-page').then(
        (c) => c.SupplierContractCreatePage,
      ),
    loadChildren: () =>
      import('./supplier-contract-create.routes').then((m) => m.SUPPLIER_CONTRACT_CREATE_ROUTES),
  },
  {
    path: ':supplierContractId',
    canActivate: [
      energyInterfacesLoadedGuard,
      locationsLoadedGuard,
      supplierContractLoadedGuard,
      supplierContractChecksStoreSetupGuard,
    ],
    component: SupplierContractsDetailsPage,
    providers: [SupplierContractChecksStore],
    children: [
      {
        path: 'general',
        component: SupplierContractDetailsGeneralPage,
      },
      {
        path: 'price',
        canActivate: [energyInterfacesLoadedGuard],
        component: SupplierContractsDetailsPricePage,
      },
      {
        path: 'check',
        component: SupplierContractDetailsCheckPage,
        canActivate: [supplierContractChecksLoadedGuard],
      },
      {
        path: 'admin-edit',
        canActivate: [energyInterfacesLoadedGuard, locationsLoadedGuard, roleGuard('USER_ADMIN')],
        loadComponent: () =>
          import('./legacy/supplier-contract-details-admin-edit-page/supplier-contract-details-admin-edit-page').then(
            (c) => c.SupplierContractDetailsAdminEditPage,
          ),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'general',
      },
    ],
  },
];
